import React from 'react';
import classes from '../FitnessPreview.module.scss'
const StopwatchSvg = () => (
    <svg className={classes.icon} width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="8" fill="#F2F7FB" />
        <path d="M29.2923 23.0417C29.2923 27.0667 26.0257 30.3333 22.0007 30.3333C17.9757 30.3333 14.709 27.0667 14.709 23.0417C14.709 19.0167 17.9757 15.75 22.0007 15.75C26.0257 15.75 29.2923 19.0167 29.2923 23.0417Z" stroke="#3ECAE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M22 18.667V22.8337" stroke="#3ECAE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19.5 13.667H24.5" stroke="#3ECAE3" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export default StopwatchSvg